<template>
  <div class="property_wraps">
    <div class="pro_top">商品组合</div>
    <div class="pro_con">
      <el-form ref="form" label-width="100px">
		  <div>请选择商品样式</div>
		  <div @change="type">
			  <div>
				  <!-- <p>经典单排</p> -->
				  <el-radio v-model="radio" label="1">经典单排</el-radio>
				  <div class="box">
					  <img src="../../../public/static/img/image.png" alt="">
					  <div>
						  <div class="titles">{{textarea}}</div>
						  <div class="tag">
							  <!-- <div class="tag1">本店浏览量第1</div> -->
							  <div class="tag1">
								  限时优惠
								  <!-- <img style="width: 100%;height: 100%;" src="../../assets/imgs/marshalling3.png" alt=""> -->
							  </div>
							  <div class="tag1">
								  店铺推荐
							  </div>
							  <div class="tags">爆款</div>
							  <div class="tags">新品</div>
						  </div>
						  <div class="price">
							  <span style="font-size: 11px;">¥<span class="PresentPrice">90</span></span>
							  <span class="originalPrice">¥120</span>
						  </div>
					  </div>
				  </div>
			  </div>
			  <div class="link"></div>
			  <div>
				  <!-- <p>经典双排</p> -->
				  <el-radio v-model="radio" label="2">经典双排</el-radio>
				  <div class="box2">
					  <div>
						  <img src="../../../public/static/img/image.png" alt="">
						  <div class="title">比苹果X还薄的笔记本电脑折叠支架</div>
						  <div class="DoubleRowTag">
							  <div class="tags2">爆款</div>
							  <div class="tags2s">新品</div>
						  </div>
						  <div class="DoubleRowPrice">
							  <span style="font-size: 11px;color: #FF1212;">¥<span class="PresentPrice">90</span></span>
							  <!-- <span class="PresentPrice">¥90</span> -->
							  <span class="originalPrice">¥120</span>
						  </div>
						  <div style="display: flex;">
							  <div class="tag2">限时优惠</div>
							  <div class="tag2">店铺推荐</div>
						  </div>
						  
					  </div>
					  <div>
						  <img src="../../../public/static/img/image.png" alt="">
						  <div class="title">比苹果X还薄的笔记本电脑折叠支架</div>
						  <!-- <div class="DoubleRowTag">
							  <div class="tags2">爆款</div>
							  <div class="tags2s">新品</div>
						  </div> -->
						  <div class="DoubleRowPrice">
							  <span style="font-size: 11px;color: #FF1212;">¥<span class="PresentPrice">90</span></span>
							  <!-- <span class="PresentPrice">¥90</span> -->
							  <span class="originalPrice">¥120</span>
						  </div>
						  <div style="display: flex;">
							  <div class="tag2">限时优惠</div>
							  <div class="tag2">店铺推荐</div>
						  </div>
					  </div>
				  </div>
			  </div>
			  <div class="link"></div>
			  <div>
				  <!-- <p>单排简易版</p> -->
				  <el-radio v-model="radio" label="3">单排简易版</el-radio>
				  <div class="box3">
						  <img src="../../../public/static/img/image.png" alt="">
				  </div>
			  </div>
			  <div class="link"></div>
			  <div>
				  <!-- <p>双排简易版</p> -->
				  <el-radio v-model="radio" label="4">双排简易版</el-radio>
				  <div class="box4">
						  <img src="../../../public/static/img/image.png" alt="">
						  <img src="../../../public/static/img/image.png" alt="">
				  </div>
			  </div>
			  <div class="link"></div>
		  </div>
        <!-- <el-form-item label="产品图编辑:">
          <div style="overflow: hidden;">
            <draggable v-model="form.pic" :options="{draggable:'.draggableItem',animation: 150}" :move="getdata"
                       @update="datadragEnd" class="draggable-body-list">
              <transition-group class="draggable-body">
                <div v-for="(item,index) in form.pic" :key="item" class="draggableItem" :draggable="draggable"
                     :style="{backgroundImage:'url('+item+')',backgroundSize:'cover',backgroundPosition:'center'}"
                  :class="currentindex==index?'activedraggable':''" @click.stop="indexLine(index)">
                  <i class="el-icon-circle-close" @click="detelFn(index)"></i>
                </div>
              </transition-group>
            </draggable>
          </div>
          <div>
            <div class="img_body" @click="showCropper">
              <p class="img_up_text">点击上传</p>
            </div>
            <p class="prompInfo">第一张默认为封面,可以拖拽图片调整顺序，最多上传5张，尺寸702*960比例，大小在2M以内</p>
            end
          </div>
        </el-form-item> -->
      </el-form>
	  <!-- <el-popover
	    placement="right"
	    width="400"
	    trigger="click">
		<div class="CommodityTitle">
			<span>商品标题:</span>
			<el-input
			  type="textarea"
			  placeholder="请输入内容"
			  v-model="textarea"
			  maxlength="30"
			  show-word-limit
			  @input="aaa"
			>
			</el-input>
		</div>
		<div @change="faddishs" class="labelBox">
			<span>爆款标签</span>
			<div>
				<el-radio v-model="faddish" label="1">显示</el-radio>
				<el-radio v-model="faddish" label="2">不显示</el-radio>
			</div>
		</div>
		<div @change="newProducts" class="labelBox">
			<span>新品标签</span>
			<div>
				<el-radio v-model="newProduct" label="1">显示</el-radio>
				<el-radio v-model="newProduct" label="2">不显示</el-radio>
			</div>
		</div>
		<div @change="views" class="labelBox">
			<span>本店浏览量第一</span>
			<div>
				<el-radio v-model="view" label="1">固定该商品</el-radio>
				<el-radio v-model="view" label="2">系统选择</el-radio>
			</div>
		</div>
		<div @change="sales" class="labelBox">
			<span>本店销量第一</span>
			<div>
				<el-radio v-model="sale" label="1">固定该商品</el-radio>
				<el-radio v-model="sale" label="2">系统选择</el-radio>
			</div>
		</div>
	    <el-button slot="reference" class="edit">选好了，前往编辑信息</el-button>
	  </el-popover> -->
	  <!-- <button class="edit" @click="edit">选好了，前往编辑信息</button>
	  <div class="popups">
		  
	  </div> -->

    </div>
    <corpper :visible.sync="corppervisible"
             v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="imgSize"></corpper>
  </div>
</template>
<script>
  import api from "@/api.js"
  import uploadImg from "@/components/dialog/uploadImg.vue";
  import corpper from "@/components/dialog/corpper.vue";
  import draggable from 'vuedraggable';

  export default {
    props: ["property"],
    components: {
      uploadImg,
      corpper,
      draggable
    },
    data() {
      return {
		radio: '1',
		faddish: '1',
		newProduct: '1',
		sale: '1',
		view: '1',
		textarea: '燃动芳华抗菌防螨羽绒被子单双人秋冬保暖被芯',
        uploadImg: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        dialogImageUrl: '',
        dialogVisible: false,
        fileList: [],
        form: {
			radios:1,
			name:"经典单排",
			faddish: 1,
			newProduct: 1,
			sale: 1,
			view: 1,
			textareas: '燃动芳华抗菌防螨羽绒被子单双人秋冬保暖被芯',
          // pic: []
        },
        imgSize: 9,
        corppervisible: false,
      };
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      property: {
        immediate: true,
        handler(val) {
			// console.log(val,"val124=====")
			// val.radios = this.form.radios
			// val.faddish = this.form.faddish
			// val.newProduct = this.form.newProduct
          this.form = val
        }
      }
    },
    created() {
      // if (this.property.pic.length !== 0) {
      //   let fileList = []
      //   for (let i in this.property.pic) {
      //     let fileList_line = {};
      //     fileList_line.name = i;
      //     fileList_line.url = this.property.pic[i];
      //     fileList.push(fileList_line)
      //   }
      //   this.fileList = fileList
      // }
    },
    mounted() {
		// console.log(this.radio,"this.radio140========")
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form)
	  // this.$emit('property', this.form)
    },
    methods: {
		// aaa(e){
		// 	console.log(e,"e220===========")
		// 	this.textarea = e
		// 	this.form.textareas = e
		// 	console.log(this.textarea, this.form.textareas,"this.form.textareas223===========")
		// },
		type(e){
			console.log(e,"e254*/*/*/**/*/=*/=*/=*/=*/=")
			this.radio = e.target.value
			this.form.radios = e.target.value
			if(this.form.radios == 1){
				this.form.name = "经典单排"
			}else if(this.form.radios == 2){
				this.form.name = "经典双排"
			}else if(this.form.radios == 3){
				this.form.name = "单排简易版"
			}else if(this.form.radios == 4){
				this.form.name = "双排简易版"
			}
			// this.$emit('property', this.form)
		},
		// // 爆款标签
		// faddishs(e){
		// 	console.log(e,"e185===========")
		// 	this.faddish = e.target.value
		// 	this.form.faddish = e.target.value
		// 	// this.$emit('update:property', this.form)
		// },
		// // 新品标签
		// newProducts(e){
		// 	console.log(e,"e185===========")
		// 	this.newProduct = e.target.value
		// 	this.form.newProduct = e.target.value
		// 	console.log(this.newProduct,this.form.newProduct,"this.form.newProduct195=========")
		// 	// this.$emit('update:property', this.form)
		// },
		// // 浏览量标签
		// views(e){
		// 	console.log(e,"e185===========")
		// 	this.view = e.target.value
		// 	this.form.view = e.target.value
		// 	console.log(this.view,this.form.view,"this.form.newProduct225=========")
		// 	// this.$emit('update:property', this.form)
		// },
		// // 销量标签
		// sales(e){
		// 	console.log(e,"e185===========")
		// 	this.sale = e.target.value
		// 	this.form.sale = e.target.value
		// 	console.log(this.sale,this.form.sale,"this.form.newProduct233=========")
		// 	// this.$emit('update:property', this.form)
		// },
		// edit(){
			// console.log(1111)
			// popups.
		// }
      // handleRemove(file, fileList) {
      //   let pic = []
      //   for (let i in  fileList) {
      //     pic.push(fileList[i].response.path)
      //   }
      //   this.form.pic = pic
      // },
      // handlePictureCardPreview(file) {
      //   this.dialogImageUrl = file.url;
      //   this.dialogVisible = true;
      // },
      // handleSuccess(response, file, fileList) {
      //   if (response.code === 0) {
      //     let pic = []
      //     for (let i in  fileList) {
      //       pic.push(fileList[i].response.path)
      //     }
      //     this.form.pic = pic
      //   }
      //   this.loadingStatus.close();
      // },
      // beforeAvatarUpload(file) {
      //   const isLt2M = file.size / 1024 / 1024 < 1;
      //   if (!isLt2M) {
      //     this.$message.error('上传图片大小不能超过 1MB!');
      //   }
      //   this.loadingStatus = this.$loading({
      //     lock: true,
      //     text: '上传中',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.4)',
      //     customClass: 'fontColor'
      //   });
      //   return isLt2M;
      // },
      // getChildValue(option) {
      //   this.form.pic = option
      // },
      // showCropper() {
      //   this.corppervisible = true
      // },
      // imgAddBack(option) {
      //   this.form.pic.push(option)
      // },
      // datadragEnd(evt) {
      //   this.currentindex = evt.newIndex
      // },
      // detelFn(index) {
      //   this.form.pic.splice(index, 1)
      // },
    }
  };
</script>

<style>
	.link{
		width: 100%;
		border-bottom: 1px solid #e9e7ef;
		margin: 10px auto;
	}
	.box{
		width: 100%;
		height: auto;
		display: flex;
		/* border: 1px solid black; */
		background-color: black;
		color: white;
	}
	.box >img{
		width: 133px;
		height: 133px;
		margin: 25px 20px;
	}
	.box >div{
		width: 188px;
		margin: 25px 14px 0px 0px;
	}
	.box >div > .titles{
		font-size: 15px;
	}
	.tag{
		width: 80%;
		flex-wrap: wrap;
		display: flex;
	}
	.tag1{
		width: 55px;
		height: 15px;
		line-height: 15px;
		text-align: center;
		background-color: burlywood;
		/* border: 1px solid bisque; */
		border-radius: 10px;
		margin-right: 10px;
		margin-top: 10px;
		color: black;
		font-size: 10px;
	}
	.tags{
		width: 29px;
		height: 15px;
		font-size: 10px;
		text-align: center;
		/* border: 1px solid black; */
		margin-right: 10px;
		margin-top: 10px;
		/* border-top-left-radius: 35px;
		border-bottom-left-radius: 35px;
		border-bottom-right-radius: 35px; */
		/* background-color: bisque; */
		background-image: url("../../assets/imgs/rectangular.png");
		background-size: 29px 15px;
		background-repeat: no-repeat;
		color: black;
	}
	.price{
		margin-top: 20px;
		color: white;
	}
	.PresentPrice{
		color: white;
		margin-right: 10px;
		font-size: 20px;
	}
	.originalPrice{
		color: #999999;
		text-decoration: line-through;
		font-size: 12px;
	}
	.box2{
		width: 100%;
		/* height: 300px; */
		height: auto;
		display: flex;
		flex-wrap: wrap;
		/* border: 1px solid black; */
		margin-top: 10px;
		background-color: whitesmoke;
	}
	.box2 >div{
		width: 45%;
		height: auto;
		/* border: 1px solid black; */
		margin-left: 10px;
		margin-top: 10px;
		border-radius: 10px;
		background-color: white;
	}
	.box2 >div >img{
		width: 100%;
		height: 159px;
		/* border: 1px solid black; */
	}
	.title{
		width: 90%;
		margin-left: 10px;
		margin-bottom: 0px;
		font-size: 15px;
		margin-top: 10px;
	}
	.DoubleRowTag{
		width: 55%;
		margin-left: 10px;
		display: flex;
	}
	.tags2{
		width: 29px;
		height: 15px;
		text-align: center;
		margin-right: 5px;
		margin-top: 10px;
		/* border-top-left-radius: 35px;
		border-bottom-left-radius: 35px;
		border-bottom-right-radius: 35px;
		background-color: #ff461f; */
		background-image: url("../../assets/imgs/rectangle.png");
		background-size: 29px 15px;
		background-repeat: no-repeat;
		color: white;
		font-size: 10px;
	}
	.tags2s{
		width: 29px;
		height: 15px;
		text-align: center;
		/* margin-right: 20px; */
		margin-top: 10px;
		/* border-top-left-radius: 35px;
		border-bottom-left-radius: 35px;
		border-bottom-right-radius: 35px;
		background-color: #fff143; */
		background-image: url("../../assets/imgs/orthogon.png");
		background-size: 29px 15px;
		background-repeat: no-repeat;
		color: white;
		font-size: 10px;
	}
	.DoubleRowPrice{
		width: 90%;
		margin-left: 10px;
		margin-top: 10px;
	}
	.DoubleRowPrice >span>.PresentPrice{
		color: #FF1212;
	}
	.tag2{
		width: 65px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 10px;
		/* border: 1px solid bisque; */
		border-radius: 35px;
		/* margin-right: 20px; */
		margin-top: 10px;
		color: #F73C3C;
		background: #FFF3F3;
		margin-bottom: 21px;
		margin-left: 10px;
	}
	.edit{
		width: 160px;
		/* height: 30px; */
		background: #0eb83a;
		border-radius: 10px;
		color: white;
		position: absolute;
		right: 20px;
		padding: 12px 10px;
	}
	.CommodityTitle{
		display: flex;
	}
	.el-textarea{
		width: 82%;
		margin-left: 8px;
	}
	.labelBox{
		display: flex;
		margin-bottom: 10px;
	}
	.labelBox >div{
		position: absolute;
		right: 10px;
	}
	.box3{
		width: 100%;
		height: 450px;
	}
	.box3 >img{
		width: 100%;
		height: 100%;
	}
	.box4{
		width: 100%;
		height: 140px;
	}
	.box4 >img{
		width: 50%;
		height: 100%;
	}
</style>